module.exports = __webpack_public_path__ + "img/flow2.bb0a2ee1.png";